// extracted by mini-css-extract-plugin
module.exports = {"forgotPasswordPage":"ForgotPasswordModal_forgotPasswordPage__BjRxo","userEmail":"ForgotPasswordModal_userEmail__eMYND"};